import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { setUsers } from 'app/state/ducks/users/actions'
import { Dispatch } from 'redux'

export const loadUsers = () => async (dispatch: Dispatch) => {
  const apiServerUrl = config.backendUrl
  return client.get(`${apiServerUrl}/api/access/v1/users`).then(users => {
    return dispatch(setUsers(users))
  }).catch(e => {
    console.log(e)
    return []
  })
}

export const createUser = (dto: unknown) => async () => {
  return client
    .post(`${config.backendUrl}/api/access/v1/users`, dto)
    .then((response: any) => ({ success: true, payload: response.data }))
    .catch(e => ({ success: false, payload: extractError(e) }))
}

export const updateUser = (id: string, dto: unknown) => async () => {
  return client.request({
      method: 'PATCH',
      url: `${config.backendUrl}/api/access/v1/users/${encodeURIComponent(id)}`,
      data: dto,
    }).then((response: any) => ({ success: true, payload: response.data }))
    .catch(e => ({ success: false, payload: extractError(e) }))
}

const extractError = (e: any): string => {
  const data = e?.response?.data
  if (!data) return 'Unknown error'
  if (typeof data.message === 'string') return data.message
  if (Array.isArray(data.message)) return data.message.join(', ')
  if (typeof data.error === 'string') return data.error
  return 'Unknown error'
}